import { ClientUtilities } from './../class/client-utilities';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, first, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { NfUtilities } from '../class/nf-utilities';
import { Utilities } from '../class/utilities';
import { IOrderItem } from '../component/page/company/order/interface/order-item.interface';
import { OrderFull } from '../component/page/company/order/model/order.model';
import { OrderService } from '../component/page/company/order/service/order.service';
import { StockController } from '../controllers/stock.controller';
import { NFe, detItem55 } from '../interface/NF-e';
import { MigrateDocument, NF_response } from '../interface/NF-response';
import { NFCe, detItem65 } from '../interface/NFC-e';
import { NFSe, RPS } from '../interface/NFS-e';
import { NFSE_response } from '../interface/NFSE-response';
import { City } from '../interface/city';
import { Client } from '../interface/client';
import { Company } from '../interface/company';
import { ImportedInvoice } from '../interface/imported-invoice';
import { INVOICE_EVENT_CODES, InvoiceEvent, NFSeCancellationEvent } from '../interface/invoice-event';
import { ITEM_MODIFY, ItemResponse } from '../interface/item-response';
import { Labor } from '../interface/labor';
import { NFSE_item } from '../interface/nfse-item';
import { Parcela } from '../interface/nfse-parcel';
import { Operation } from '../interface/operation';
import { pagItem } from '../interface/pag-item';
import { Part } from '../interface/part';
import { PartGroup } from '../interface/part-group';
import { PaymentCondition } from '../interface/paymentCondition';
import { Finance } from '../interface/ro-finance';
import { RoLaborFull } from '../interface/ro-labor-full';
import { RoPartFull } from '../interface/ro-part-full';
import { Supplier } from '../interface/supplier';
import { ANP_CODES } from '../shared/lists/ANP_codes';
import { CFOP_list } from '../shared/lists/cfop';
import { COUNTRIES } from '../shared/lists/country-codes';
import { DOCUMENT_TYPE_CODES } from '../shared/lists/document-type';
import { API_ERRORS } from '../shared/lists/errors';
import { INVOICE_STATE } from '../shared/lists/invoice-state';
import { PAYMENT_METHODS } from '../shared/lists/payment-methods';
import { UTRIB_BY_NCM } from '../shared/lists/utrib-by-ncm';
import { InvoicePropertyPipe } from '../shared/pipes/invoice-property.pipe';
import { AddressService } from './address.service';
import { CashTitleService } from './cash-title.service';
import { ClientService } from './client.service';
import { CompanyService } from './company.service';
import { DataService } from './data.service';
import { GroupService } from './group.service';
import { LaborService } from './labor.service';
import { LayoutService } from './layout.service';
import { OperationService } from './operation.service';
import { PartService } from './part.service';
import { PaymentService } from './payment.service';
import { RoService } from './ro.service';
import { SnackbarService } from './snackbar.service';
import { SupplierService } from './supplier.service';
import { UserService } from './user.service';
import { VehicleService } from './vehicle.service';
import { firstValueFrom, of } from 'rxjs';
import moment from 'moment';
import { MigrateCommonService } from './migrate-common.service';
import { Farm } from '../interface/farm';
import { ObjectId } from '../shared/type-aliases/object-id';
import { LOG_REPORTER_KEYS, LogReporterService } from './log-reporter.service';
import { IOsClient, IOSOperation, MkgOS, OsLaborPopulate, TaxesParamsOS } from '../class/mkg-os';
import { NcmObservationTrib } from '../interface/ncm-observation-trib';
import { partStates } from '../shared/lists/part-states';
import { laborStates } from '../shared/lists/labor-states';
import { MkgOSPart } from '../class/mkg-os-part';
import { Money } from '../class/money';
import { SessionOSservice } from './session/session-os.service';
import { IbptImportService } from './ibpt-import.service';
import { ReduceSumPipe } from '../shared/pipes/reduce-sum.pipe';
import { CNAE } from "t5-common";
import { MigrateQueryResponse } from '../interface/fiscal/migrate-query-response';
import { PartUtilities } from '../class/part-utilities';
import Decimal from 'decimal.js';
import { AddressState } from '../interface/state';
import { IND_PRES } from '../shared/enums/fiscal/ind-pres';
import { FiscalLaborsInvoiceModels, FiscalPartsInvoiceModels, GerencialLaborsInvoiceModels, GerencialPartsInvoiceModels } from '../interface/mkgo-invoice';
import { ApiPaginatedInvoiceQueryParams } from './pagination.service';
import { IOrder } from '@app/component/page/company/order/interface/order.interface';
import { VehicleUtilities } from '../class/vehicle-utilities';
import { N_TIPO_ITEM } from '@app/shared/enums/fiscal/n-tipo-item';
import { LogInvoicesService } from './log-invoices.service';
import { INVOICE_LOG_ACTION_TYPES } from '@app/interface/log-invoices-interfaces';
import { IND_IE_DEST } from '@app/shared/enums/fiscal/ind-ie-dest';
import { IND_FINAL } from '@app/shared/enums/fiscal/ind-final';
import { ID_DEST } from '@app/shared/enums/fiscal/id-dest';
import { TP_NF } from '@app/shared/enums/fiscal/tp-nf';
import { FIN_NFE } from '@app/shared/enums/fiscal/fin-nfe';


export type InvoiceRejections = null | {
  migrateCode: number,
  migrateDescription: string,
  sefazCode: SEFAZ_CODES,
  sefazDescription: string
}

export interface TaxesParams {
  client: Client;
  operation: Operation;
  ItemBaseCalculo: number;
  labor?: OsLaborPopulate;
}


const DEFAULT_PAG: pagItem[] = [{
  indPag_pag: "0",
  tPag: PAYMENT_METHODS['money'],
  vPag: 0
}];

export enum SEFAZ_CODES {
  // Autorizado o Uso
  AUTORIZADO = 100,

  /** Cancelamento homologado */
  CANCELADO = 101,

  /** Inutilização de número homologado  */
  INUTILIZADO = 102,

  /** Documento pendente  */
  PENDENTE = 105,

  /** documento não consta na base de dados do InvoiCy, caso queira enviá-lo, preencha todas as informações do evento  */
  INEXISTENTE = 106,

  /** Documento pendente em contingência  */
  CONTINGENCIA = 108,

  /** Documento está rejeitado, não é possível enviar o evento  */
  REJEITADO = 112,

  /** Documento está com status [Descrição Status]. O evento será enviado automaticamente quando o documento obtiver um status final  */
  AGUARDANDO = 113,

  /** Evento autorizado e vinculado ao documento  */
  ALTERADO = 135, // carta de correção OK

  DENEGADA = 205,

  /** Uso Denegado : Irregularidade fiscal do destinatario */
  DEVOLUCAO_DENEGADA = 302
};

@Injectable({
  providedIn: 'root'
})
export class MigrateService {
  readonly NO_ACCESS_KEY = "_SEM_CHAVE_DE_ACESSO";
  readonly URL = environment.migrate.URL;

  groupMap = new Map<string, PartGroup>();
  conditionsMap = new Map<string, PaymentCondition>();
  private _http = inject(HttpClient);
  private _dataService = inject(DataService);
  private _clientService = inject(ClientService);
  private _addressService = inject(AddressService);
  private _companyService = inject(CompanyService);
  private _cashTitleService = inject(CashTitleService);
  private _invoicePropertyPipe = new InvoicePropertyPipe();
  private _supplierService = inject(SupplierService);
  private _paymentService = inject(PaymentService);
  private _migrateCommonService = inject(MigrateCommonService);
  private _sessionOSservice = inject(SessionOSservice);

  static getDate(date = new Date()) {
    const [year, month, day, hour, minutes, seconds] = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    ].map(String).map(s => s.padStart(2, '0'));
    return `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;
  }

  static getFuso() {
    let resp = "";
    const hours = new Date().getTimezoneOffset() / 60 * -1;
    if (hours < 0) {
      resp += '-';
    }
    resp += Math.abs(hours).toString().padStart(2, '0');
    resp += ':00';
    return resp;
  }

  static getISStaxes({ company, ItemBaseCalculo }: { company: Company, ItemBaseCalculo: number }) {

    // define item ISS
    let ItemAliquota: NFSE_item['ItemAliquota'] = 0;
    let ItemvIss: NFSE_item['ItemvIss'] = 0;

    const aliquot = Number(company.ISS) || 0;
    if (aliquot) {
      ItemAliquota = aliquot;
      ItemvIss = Money(ItemBaseCalculo * aliquot / 100);
    }

    return {
      ItemAliquota,
      ItemvIss,
      ItemBaseCalculo
    }

  }

  static getInvoiceISSTaxesAndSetItemsISS({ company, items }: { company: Company, items: NFSE_item[] }) {
    let ValAliqISS: NFSe['RPS'][0]["Servico"]["Valores"]["ValAliqISS"] = Number(company.ISS) || 0;

    let ValISS: NFSe['RPS'][0]["Servico"]["Valores"]["ValISS"] = 0;

    let ValBaseCalculo: NFSe['RPS'][0]["Servico"]["Valores"]["ValBaseCalculo"] = items.reduce((finalValue, item) => finalValue.plus(new Decimal(item.ItemBaseCalculo)), new Decimal(0)).toNumber();

    if (ValAliqISS) {
      ValISS = Money(ValBaseCalculo * ValAliqISS / 100);

      Utilities.fixCentsDifference(items, "ItemvIss", ValISS);
    }

    return {
      ValAliqISS,
      ValISS,
      ValBaseCalculo
    }
  }

  static getPIStaxes({ operation, ItemBaseCalculo }: { client: Client | IOsClient, operation: Operation | IOSOperation, ItemBaseCalculo: number }) {
    let ItemValAliqPIS: NFSE_item['ItemValAliqPIS'];
    let ItemValPIS: NFSE_item['ItemValPIS'];
    let ItemValBCPIS: NFSE_item['ItemValBCPIS'];
    const aliquot = operation.PIS?.Aliquot || 0;
    if (aliquot) {
      ItemValAliqPIS = aliquot;
      ItemValPIS = Money(ItemBaseCalculo * aliquot / 100);
      ItemValBCPIS = ItemBaseCalculo;
    }

    return {
      ItemValAliqPIS,
      ItemValPIS,
      ItemValBCPIS
    }

  }

  static getCOFINStaxes({ operation, ItemBaseCalculo }: TaxesParams | TaxesParamsOS) {
    let ItemValAliqCOFINS: NFSE_item['ItemValAliqCOFINS'];
    let ItemValCOFINS: NFSE_item['ItemValCOFINS'];
    let ItemValBCCOFINS: NFSE_item['ItemValBCCOFINS'];

    const aliquot = operation.COFINS?.Aliquot || 0;
    if (aliquot) {
      ItemValAliqCOFINS = aliquot;
      ItemValCOFINS = Money(ItemBaseCalculo * aliquot / 100);
      ItemValBCCOFINS = ItemBaseCalculo;
    }

    return {
      ItemValAliqCOFINS,
      ItemValCOFINS,
      ItemValBCCOFINS
    }

  }

  static getCSLLtaxes({ operation, ItemBaseCalculo, labor }: TaxesParams | TaxesParamsOS) {
    let ItemValAliqCSLL: NFSE_item['ItemValAliqCSLL'];
    let ItemValCSLL: NFSE_item['ItemValCSLL'];
    let ItemValBCCSLL: NFSE_item['ItemValBCCSLL'];

    const aliquot = labor?.CSLL?.aliquot || operation.CSLL?.aliquot || 0
    if (aliquot) {
      ItemValAliqCSLL = aliquot;
      ItemValCSLL = Money(ItemBaseCalculo * aliquot / 100);
      ItemValBCCSLL = ItemBaseCalculo;
    }

    return {
      ItemValAliqCSLL,
      ItemValCSLL,
      ItemValBCCSLL
    }

  }

  static getIRtaxes({ operation, ItemBaseCalculo, labor }: TaxesParams | TaxesParamsOS) {
    let ItemValAliqIR: NFSE_item['ItemValAliqIR'];
    let ItemValIR: NFSE_item['ItemValIR'];
    let ItemValBCIRRF: NFSE_item['ItemValBCIRRF'];

    const aliquot = labor?.IRPJ?.aliquotLabor || operation.IRPJ?.aliquotLabor || 0;
    if (aliquot) {
      ItemValAliqIR = aliquot;
      ItemValIR = Money(ItemBaseCalculo * aliquot / 100);
      ItemValBCIRRF = ItemBaseCalculo;
    }

    return {
      ItemValAliqIR,
      ItemValIR,
      ItemValBCIRRF
    }

  }

  static getINSStaxes({ operation, ItemBaseCalculo, labor }: TaxesParams | TaxesParamsOS) {
    let ItemValAliqINSS: NFSE_item['ItemValAliqINSS'];
    let ItemValINSS: NFSE_item['ItemValINSS'];
    let ItemvalBCINSS: NFSE_item['ItemvalBCINSS'];

    const aliquot = labor?.INSS?.aliquot || operation.INSS?.aliquot || 0;
    if (aliquot) {
      ItemValAliqINSS = aliquot;
      ItemValINSS = Money(ItemBaseCalculo * aliquot / 100);
      ItemvalBCINSS = ItemBaseCalculo;
    }

    return {
      ItemValAliqINSS,
      ItemValINSS,
      ItemvalBCINSS
    }

  }

  /** avoid register the company more than one time */
  public async isCompanyCreated(company: Company) {
    return await this._migrateCommonService.isCompanyCreated(company);
  }

  /**
   * @param accessKey The migrate API access key for this company
   * @param lastNSU the company numberInvoice
   */
  public async registerCompany(accessKey: string, lastNSU: string, gerencial: boolean) {
    return await this._migrateCommonService.registerCompany(accessKey, lastNSU, gerencial);
  }

  /**
   *  @todo delete
   */
  async registerCompanyMKGO(company: Company) {
    const url = `${this.URL}/v1/companies/register`;
    const options = await firstValueFrom(this._dataService.httpOptions(false))
    const resp = await this._http.post(url, company, options).pipe(first()).toPromise();
    return resp
  }

  async getAll_NF(company: Company, filter?: Omit<ApiPaginatedInvoiceQueryParams, 'shouldReturnRequestAndResponse'>): Promise<NF_response[]> {
    if (filter) {
      return await this._migrateCommonService.getAll_NF(company, filter);
    } else {
      return await this._migrateCommonService.getAll_NF(company);
    }
  }

  /** @todo add params into getAll_NF to filter invoices without OS or order reference */
  public async getManuallyNF(company: Company): Promise<NF_response[]> {
    // verify if this company is integrated with migrate
    try {
      const created = await this.isCompanyCreated(company);
      if (!created) {
        return []
      }
    } catch (error) {
      console.error(error)
      return []
    }

    let url = `${this.URL}/v1/invoice-mkgo/nfce/no/os`;
    const options = await firstValueFrom(this._dataService.httpOptions(false));
    const resp = await this._http.get(url, options).pipe(first()).toPromise();
    // return resp as any
    return (resp as any[]).filter(resp => resp?.request?.Documento).map(nf => {
      let newDet = [];
      if (nf?.request?.Documento?.det && !Array.isArray(nf.request.Documento.det)) {
        // det need be a array
        nf.request.Documento.det = [nf.request.Documento.det];
      }

      nf.request.Documento.det.slice().map(detItem => {
        let newItem = { ...detItem };
        /**
         * detItem.imposto.ICMS.ICMS00 = { ... }
         *
         * detItem.imposto.ICMS = { ... }
         */
        const icmsTag = detItem.imposto.ICMS;
        if (icmsTag) {
          const keys = Object.keys(icmsTag);
          const childName = keys.find(key => key.startsWith('ICMS'));
          if (childName) {
            newItem['imposto']['ICMS'] = icmsTag[childName]
          }
        }

        const ipiTag = detItem.imposto.IPI;
        if (ipiTag) {
          const keys = Object.keys(ipiTag);
          const childName = keys.find(key => key.startsWith('IPI'));
          if (childName) {
            let CSTIPI = ipiTag[childName];
            CSTIPI['CST_IPI'] = CSTIPI['subkey'];

            // xml.imposto.IPI.IPINT.CST
            (newItem as detItem55)['imposto']['IPI']['CSTIPI'] = CSTIPI
          }
        }

        newDet.push(newItem);
      })
      nf.request.Documento.det = newDet;
      return nf;
    }).reverse();
  }

  async getAll_NFSE(companyLabors: Company, paginatedFilter?: Omit<ApiPaginatedInvoiceQueryParams, 'shouldReturnRequestAndResponse'>): Promise<NFSE_response[]> {
    if (paginatedFilter) {
      return await this._migrateCommonService.getAll_NFSE(companyLabors, paginatedFilter)
    } else {
      return await this._migrateCommonService.getAll_NFSE(companyLabors)
    }
  }

  /**
   * create invoice without emit into SEFAZ (GERENCIAL)
   * @param invoice The invoice to register
   * @param idOperation The operation id
   */
  public async registerGerencialNF(
    data: {
      invoice: NFCe | NFe;
      osTarget?: {
        osId: string;
        osNumber: number;
      };
      orderTarget?: {
        orderId: string;
        orderNumber: number;
      };
      idOperation: string;
      state: INVOICE_STATE.GERENCIAL | INVOICE_STATE.DEVOLUTIONED | INVOICE_STATE.GERENCIAL_DEVOLUTIONED | INVOICE_STATE.IMPORTED_VIA_XML | INVOICE_STATE.INPUT_WITHOUT_XML;
      items: ItemResponse[];
      company: Company;
      clientId?: string;
      supplierId?: string;
      devolutionOriginInvoiceId?: string;
      clientSupplierName: string;
      model: GerencialPartsInvoiceModels;
      isEntry: boolean;
      accessKey?: string;
      value: number;
      emitionDate: string;
      refundOriginId?: ObjectId;
      refundTargetId?: ObjectId;

      /** Pass true if you don't change the invoice number and serie, create as it was */
      keepNumberAndSerie?: boolean;
    }): Promise<NF_response> {
    NfUtilities.removeSpecialCharactersOf(data.invoice);
    const url = `${this.URL}/v1/invoice-mkgo/nfce`;
    let body: Partial<NF_response> = {
      operationId: data.idOperation,
      state: data.state,
      clientOrSupplierName: data.clientSupplierName,
      isFiscal: false,
      isEntry: data.isEntry,
      model: data.model as any,
      value: data.value,
      emitionDate: data.emitionDate,
      response: {
        Documentos: <NF_response['response']['Documentos']>[{
          DocChaAcesso: data.accessKey
        }]
      } as any, // gerencial invoices don't have Migrate/Sefaz responses
      items: this.removeNullValuesOf(data.items)
    };

    // get updated company, preventing wrong values for number and serie
    const company = await this._companyService.get(data.company.id, true);

    let emitterDocument = this._invoicePropertyPipe.transform(
      <NF_response>{ request: { Documento: data.invoice } }, 'cnpj', company);
    if (MigrateCommonService.isDevolution(data.invoice)) {
      emitterDocument = company.cnpj;
    }
    body.cnpjEmitente = Utilities.removeMask(emitterDocument);

    if (data.keepNumberAndSerie) {
      body.numero = this._invoicePropertyPipe.transform(<NF_response>{ request: { Documento: data.invoice } }, "number", company);
      body.serie = this._invoicePropertyPipe.transform(<NF_response>{ request: { Documento: data.invoice } }, "serie", company);
      await this._getNextNumberAndSerieFor(company, emitterDocument, "NFe", false)
    } else {
      const { numero, serie } = await this._getNextNumberAndSerieFor(company, emitterDocument, "NFe", false);
      body.numero = `${numero}`;
      body.serie = `${serie}`;
      data.invoice.ide.nNF = numero;
      data.invoice.ide.serie = serie;
    }

    if (data.invoice.emit?.xNome) {
      data.invoice.emit.xNome = Utilities.limitCharacterLength(data.invoice.emit.xNome, 60);
    }

    if (data.invoice.emit?.xFant) {
      data.invoice.emit.xFant = Utilities.limitCharacterLength(data.invoice.emit.xFant, 60);
    }

    if (data.invoice.dest?.xNome_dest) {
      data.invoice.dest.xNome_dest = Utilities.limitCharacterLength(data.invoice.dest.xNome_dest, 60);
    }

    if (data.devolutionOriginInvoiceId) {
      body.devolutionOriginInvoiceId = data.devolutionOriginInvoiceId;
    }

    body.request = { Documento: data.invoice };
    if (data?.osTarget?.osId) {
      body.osId = data.osTarget.osId;
      body.osNumber = data.osTarget.osNumber;
    }
    if (data?.orderTarget?.orderId) {
      body.orderID = data.orderTarget.orderId;
      body.orderNumber = data.orderTarget.orderNumber;
    }
    if (data.clientId) {
      body.clientId = data.clientId;
    }
    if (data.supplierId) {
      body.supplierId = data.supplierId;
    }
    if (data.refundOriginId) {
      body.refundOriginId = data.refundOriginId;
    }
    if (data.refundTargetId) {
      body.refundTargetId = data.refundTargetId;
    }

    let options = await firstValueFrom(this._dataService.httpOptions(company.cnpj));
    const resp = await firstValueFrom(this._http.post<[NF_response] | NF_response>(url, body, options));
    if (Array.isArray(resp)) {
      return resp[0];
    } else {
      return resp;
    }
  }

  /**
   * @param osId id of OS or operation
   * @param state use a `INVOICE_STATE` key value
   * @param parts use `getItemsToUpdate()` function to get this value
   */
  // async updateNF(id: string, model: 'NFCe' | 'NFe', operationId: string, osId: string, parts: ItemResponse[], newNF?: NFe | NFCe, invoiceNumber?: number): Promise<NF_response> {
  async updateNF(
    data: {
      company: Company;
      id: string;
      model: 'NFCe' | 'NFe';
      operation: Operation;
      OS: MkgOS;
      parts: ItemResponse[];
      newNF?: NFe | NFCe;
      invoiceNumber?: number;
      orderID?: string;
      oldInvoice: NF_response;
      refundOriginId?: ObjectId;
      refundTargetId?: ObjectId;
    }): Promise<NF_response> {
    const { newNF, oldInvoice } = data;
    let body: Partial<NF_response> & { userId: string } = {
      userId: this._dataService.user._id ?? this._dataService.user.id,
      operationId: data.operation.id,
      state: INVOICE_STATE.PENDING,
      request: {
        Documento: newNF
      }
    };

    const invoicePropertyPipe = new InvoicePropertyPipe();
    const model = oldInvoice.model ?? invoicePropertyPipe.transform(oldInvoice, "model");
    const value = data.newNF.total.ICMStot.vNF ?? invoicePropertyPipe.transform(oldInvoice, "value");
    const isEntry = oldInvoice.isEntry ?? data.operation.entry;
    const isFiscal = oldInvoice.isFiscal ?? data.operation.docFiscal;

    if (oldInvoice.supplierId) {
      body["supplierId"] = oldInvoice.supplierId;
    } else if (oldInvoice.clientId) {
      body["clientId"] = oldInvoice.clientId;
    }

    body["isEntry"] = isEntry;
    body["isFiscal"] = isFiscal;
    body["value"] = value;
    body["model"] = model;
    body["emitionDate"] = moment(newNF.ide.dhEmi).toISOString();

    if (data.refundOriginId) {
      body['refundOriginId'] = data.refundOriginId;
    } else if (oldInvoice.refundOriginId) {
      body['refundOriginId'] = oldInvoice.refundOriginId;
    }

    if (data.refundTargetId) {
      body['refundTargetId'] = data.refundTargetId;
    } else if (oldInvoice.refundTargetId) {
      body['refundTargetId'] = oldInvoice.refundTargetId;
    }

    if (oldInvoice.osId && oldInvoice.osNumber) {
      body["osNumber"] = oldInvoice.osNumber;
      body["osId"] = oldInvoice.osId;
    }

    if (oldInvoice.orderID && oldInvoice.orderNumber) {
      body["orderNumber"] = oldInvoice.orderNumber;
      body["orderID"] = oldInvoice.orderID;
    }

    let client_supplier: Client | Supplier;
    let isSupplier: boolean;
    const { clientId, supplierId } = oldInvoice;

    try {
      if (clientId) {
        client_supplier = await this._clientService.get(clientId);
        isSupplier = false;
      } else if (supplierId) {
        client_supplier = await this._supplierService.get(supplierId);
        isSupplier = true;
      }

    } catch (error) {
      console.error(error);
      console.error(`Cliente/fornecedor com o id ${clientId ?? supplierId} não encontrado`);
    }

    if (!client_supplier) {
      const personName = invoicePropertyPipe.transform(oldInvoice, "client", data.company);
      body["clientOrSupplierName"] = personName;

      if (clientId) {
        body.clientId = clientId;
      }

      if (supplierId) {
        body.supplierId = supplierId;
      }
    } else {
      body["clientOrSupplierName"] = client_supplier.name;
      body[isSupplier ? 'supplierId' : 'clientId'] = client_supplier.id;
    }

    NfUtilities.removeSpecialCharactersOf(newNF);
    delete newNF['ide']['accessKey'];
    if (!newNF.ide.EmailArquivos) {
      delete newNF.ide.EmailArquivos
    }

    let cleanInvoice = Utilities.removeNull(newNF, true);

    if (!Object.keys(newNF).length) {
      throw new Error("Invalid document");
    }

    const cnpj = data.company.cnpj;
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${data.id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));

    body["request"]["Documento"] = cleanInvoice;

    body['numero'] = this._invoicePropertyPipe.transform(body as any, 'number').toString();
    body['serie'] = data.model === "NFe" ? data.company.serieInvoice?.toString() : data.company.serieInvoiceNFC?.toString();
    body['cnpjEmitente'] = Utilities.removeMask(cnpj);

    if (!body['osId']) {
      delete body['osId'];
    }
    if (!body['orderID']) {
      delete body.orderID
    }
    const resp = await this._http.put(url, body, options).pipe(first()).toPromise();
    return resp as NF_response
  }

  async updateNFSe(data: {
    id: string;
    osId: string;
    operationId: string;
    labors: ItemResponse[];
    newNFSE: NFSe;
    invoiceNumber?: number;
    oldInvoice: NFSE_response;
  }): Promise<NFSE_response> {
    let body: Partial<NFSE_response> & { userId: string } = {
      userId: this._dataService.user._id ?? this._dataService.user.id,
      operationId: data.operationId,
      state: INVOICE_STATE.PENDING,
      items: data.labors.slice().map(item => {
        return {
          amount: item.amount,
          code: item.code?.trim(),
          keyId: item.keyId,
          modify: item.modify || ITEM_MODIFY.not_modified
        }
      }),
      serie: data.newNFSE.RPS[0].RPSSerie,
      request: {
        Documento: data.newNFSE
      }
    };
    const oldInvoice = data.oldInvoice;

    const invoicePropertyPipe = new InvoicePropertyPipe();
    const model = oldInvoice.model ?? invoicePropertyPipe.transform(oldInvoice, "model");
    const value = data.newNFSE.RPS[0].Servico?.Valores?.ValLiquido ?? invoicePropertyPipe.transform(oldInvoice, "value");

    let company = this._dataService.company;
    let invoice: NFSe = data.newNFSE;
    const dEmit = data.newNFSE.RPS[0].dEmis;

    const isEntry = oldInvoice.isEntry;
    const isFiscal = oldInvoice.isFiscal;

    body.emitionDate = moment(dEmit).toISOString();

    body["isEntry"] = isEntry;
    body["isFiscal"] = isFiscal;
    body["value"] = value;
    body["model"] = model;
    body["emitionDate"] = moment().toISOString();

    let client_supplier: Client | Supplier;
    let isSupplier: boolean;
    const { clientId, supplierId } = oldInvoice;

    try {
      if (clientId) {
        client_supplier = await this._clientService.get(clientId);
        isSupplier = false;
      } else if (supplierId) {
        client_supplier = await this._supplierService.get(supplierId);
        isSupplier = true;
      }
    } catch (error) {
      console.error(error);
      console.error(`Cliente/fornecedor com o id ${clientId ?? supplierId} não encontrado`);
    }

    if (!client_supplier || ClientUtilities.isDefault(client_supplier?.document)) {
      const personName = invoicePropertyPipe.transform(oldInvoice, "client", company);
      body["clientOrSupplierName"] = personName;
    } else {
      body["clientOrSupplierName"] = client_supplier.name;
      body[isSupplier ? 'supplierId' : 'clientId'] = client_supplier.id;
    }

    if (!Object.keys(invoice).length) {
      throw new Error("Invalid document");
    }

    const url = `${this.URL}/v1/invoice-mkgo/nfse/${data.id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(company.cnpj));
    NfUtilities.removeSpecialCharactersOf(invoice);

    if (oldInvoice.osId) {
      await firstValueFrom(this._sessionOSservice.forceCloseAllSessions(oldInvoice.osId));
      body.osId = oldInvoice.osId;
      body.osNumber = oldInvoice.osNumber;
    }

    return firstValueFrom(this._http.put<NFSE_response>(url, body, options));
  }

  async getUpdatedInvoiceState(invoice: NF_response | NFSE_response) {
    let errors: InvoiceRejections;
    const model = this._invoicePropertyPipe.transform(invoice, 'model');
    let queryResponse: MigrateQueryResponse;
    if (model === 'NFSE') {
      queryResponse = await this.getUpdatedNFSe(invoice as NFSE_response);
    } else {
      queryResponse = await this.getUpdatedNF(invoice as NF_response, model);
    }
    errors = MigrateCommonService.getRejectionsOfConsult(queryResponse);
    return errors;
  }

  async cancelInvoice(invoice: NF_response, reazon: string, cnpj: string): Promise<NF_response> {
    const nf = invoice.request.Documento as NFCe | NFe;
    const nfSerie = nf.ide.serie;
    const nfNumber = nf.ide.nNF
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${invoice.id}/cancel`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));

    const cancelEvent: InvoiceEvent = {
      NtfCnpjEmissor: cnpj,
      NtfNumero: nfNumber,
      NtfSerie: nfSerie.toString(),
      tpAmb: environment.migrate.tpAmb,
      EveInf: {
        EveDh: MigrateService.getDate(),
        EveFusoHorario: MigrateService.getFuso(),
        EveTp: INVOICE_EVENT_CODES["Cancelamento"],
        EvenSeq: 1,
        Evedet: {
          EveDesc: "Cancelamento",
          EvexJust: reazon
        }
      }
    };

    const body = {
      operationId: invoice.operationId,
      "state": invoice.state,
      request: {
        ModeloDocumento: invoice.request.Documento.ModeloDocumento,
        Versao: 4.0,
        Evento: cancelEvent,
      }
    };

    const resp = await this._http.put(url, body, options).pipe(first()).toPromise();
    return resp as any;
  }

  async correctionLetterInvoice(invoice: NF_response, reazon: string): Promise<NF_response | NFSE_response> {
    const nf = invoice.request.Documento as NFCe | NFe;
    const cnpj = this._invoicePropertyPipe.transform(invoice, "cnpj");
    const nfSerie = nf.ide.serie;
    const nfNumber = nf.ide.nNF;
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${invoice.id}/cancel`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    let EvenSeq = 1;
    const [doc] = invoice.response2?.Documentos || [];
    if (doc) {
      const seq = (doc as MigrateDocument).DocEvenSeq || 0;
      EvenSeq = seq + 1;
    }

    const correctionLetterEvent: InvoiceEvent = {
      NtfCnpjEmissor: nf.emit.CNPJ_emit,
      NtfCpfEmissor: nf.emit.CPF_emit,
      NtfNumero: nfNumber,
      NtfSerie: nfSerie.toString(),
      tpAmb: environment.migrate.tpAmb,
      EveInf: {
        EveDh: MigrateService.getDate(),
        EveFusoHorario: MigrateService.getFuso(),
        EveTp: INVOICE_EVENT_CODES["CC-e"],
        EvenSeq,
        Evedet: {
          EveDesc: "Carta de Correcao",
          EveCorrecao: reazon,
          EveCondUso: "A Carta de Correcao e disciplinada pelo paragrafo 1o-A do art. 7o do Convenio S/N, de 15 de dezembro de 1970 e pode ser utilizada para regularizacao de erro ocorrido na emissao de documento fiscal, desde que o erro nao esteja relacionado com: I - as variaveis que determinam o valor do imposto tais como: base de calculo, aliquota, diferenca de preco, quantidade, valor da operacao ou da prestacao; II - a correcao de dados cadastrais que implique mudanca do remetente ou do destinatario; III - a data de emissao ou de saida."
        }
      }
    };

    const body = {
      operationId: invoice.operationId,
      "state": invoice.state,
      request: {
        ModeloDocumento: invoice.request.Documento.ModeloDocumento,
        Versao: 4.0,
        Evento: correctionLetterEvent,
      }
    };

    const resp = await this._http.put(url, body, options).pipe(first()).toPromise();
    return resp as any;
  }

  async cancelNFSe(invoice: NFSE_response, reazon: string): Promise<NFSE_response> {
    const nfse = invoice.request.Documento as NFSe;
    const cnpj = nfse.RPS[0].Prestador.CNPJ_prest;
    const { RPSSerie, RPSNumero } = nfse.RPS[0];
    const url = `${this.URL}/v1/invoice-mkgo/nfse/${invoice.id}/cancel`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const [response1] = (invoice as NFSE_response).response && Array.isArray((invoice as NFSE_response).response.Documentos) ? (invoice as NFSE_response).response.Documentos : [];
    const NFSeNumero = response1?.NFSe?.NFSeNumero;

    const cancelEvent: NFSeCancellationEvent = {
      ModeloDocumento: invoice.request.Documento.ModeloDocumento,
      Versao: 1,
      Evento: {
        CNPJ: cnpj.replace(/\D/g, ''),
        NFSeNumero,
        RPSNumero,
        RPSSerie,
        IDUnico: "",
        EveTp: 110111,
        tpAmb: environment.migrate.tpAmb,
        EveCodigo: "1",
        EveMotivo: reazon,
        NFSeCodVerificacao: "",
        Protocolo: "",
        SituacaoNota: 0,
        NumeroLote: 0,
        IntegridadeOCR: "",
        CancelamentoViaTela: ""
      }
    };

    const body = {
      operationId: invoice.operationId,
      "state": invoice.state,
      request: cancelEvent
    };

    const resp = await firstValueFrom(this._http.put(url, body, options));
    return resp as any;
  }

  /**
   * Use only to delete a gerencial invoice
   */
  async deleteInvoice(id: string, type: 'nfce' | 'nfse', cnpj: string) {
    const url = `${this.URL}/v1/invoice-mkgo/${type}/${id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const resp = await this._http.delete(url, options).pipe(first()).toPromise();
    return resp;
  }

  public async deny(id: string, invoice: NFe | NFCe, reazon: string, cnpj: string): Promise<NF_response> {
    if (!invoice.ModeloDocumento) {
      invoice.ModeloDocumento = invoice.ide.mod == '55' ? "NFe" : "NFCe";
    }
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${id}/disable`;
    console.log("inutilizar", invoice);

    const emitState = await firstValueFrom(this._addressService.states$.pipe(
      map(states => states.find(s => s.code === invoice.emit.enderEmit.UF))
    ));

    const body = {
      "ModeloDocumento": invoice.ModeloDocumento,
      "Versao": "4.00",
      "UfEmissor": Number(emitState.uf),
      "NumeroInicial": invoice.ide.nNF.toString(),
      "NumeroFinal": invoice.ide.nNF.toString(),
      "Serie": invoice.ide.serie.toString(),
      "Justificativa": reazon
    };
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.post<NF_response>(url, body, options).pipe(
      first(),
    ));
  }

  public async getItemsFromInvoice(invoiceId: string, cnpj: string, isNFSE = false) {
    const url = `${this.URL}/v1/invoice-mkgo/${isNFSE ? 'nfse' : 'nfce'}/${invoiceId}/item`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.get<ItemResponse[]>(url, options));
  }

  public async getItemsOfInvoices(invoiceIds: string[], cnpj: string): Promise<ItemResponse[]> {
    if (!invoiceIds || invoiceIds.length === 0) {
      return [];
    }
    const url = `${this.URL}/v1/invoice-mkgo/nfce/items/by-invoices`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.post<ItemResponse[]>(url, { invoiceIds }, options));
  }

  public async getInvoicesWithItems(filters: any, cnpj: string): Promise<NF_response[]> {
    const url = `${this.URL}/v1/invoice-mkgo/nfce/with-items`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.post<NF_response[]>(url, filters, options));
  }

  public async getNFSEWithItems(filters: any, cnpj: string): Promise<NFSE_response[]> {
    const url = `${this.URL}/v1/invoice-mkgo/nfse/with-items`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.post<NFSE_response[]>(url, filters, options));
  }

  public async addItemsToInvoice(items: ItemResponse[], invoiceId: string, cnpj: string) {
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${invoiceId}/item`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const validItems = this.removeNullValuesOf(items);
    for (const item of validItems) {
      if (item.code) {
        item.code = (`${item.code}`).trim();
      }
    }
    const resp = await this._http.post(url, { items: validItems }, options).pipe(first()).toPromise();
    return resp;
  }

  public async removeItemFromInvoice(itemId: string, invoiceId: string, cnpj: string) {
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${invoiceId}/item/${itemId}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const resp = await this._http.delete(url, options).pipe(first()).toPromise();
    return resp;
  }

  public async updateItemIntoInvoice(
    item: ItemResponse,
    invoiceId: string,
    cnpj: string,
    devolutionLinkage?: { devolutionInvoiceId: string; devolutionItemId: string },
  ) {
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${invoiceId}/item/${item['id']}`;
    const modifiedItem: ItemResponse & { devolutionInvoiceId?: string; devolutionItemId?: string } = {
      amount: item.amount || -1, // full devolutioned items have -1 as amount avalable to devolution
      code: item.code?.trim(),
      keyId: item.keyId,
      nItem: item.nItem,
      modify: ITEM_MODIFY.modified,
    };

    if (![null, undefined].includes(item?.remainingDiscountValue)) {
      modifiedItem.remainingDiscountValue = item?.remainingDiscountValue;
    }

    if (![null, undefined].includes(item?.remainingFreightValue)) {
      modifiedItem.remainingFreightValue = item?.remainingFreightValue;
    }

    if (![null, undefined].includes(item?.remainingInsuranceValue)) {
      modifiedItem.remainingInsuranceValue = item?.remainingInsuranceValue;
    }

    if (![null, undefined].includes(item?.remainingOtherExpensesValue)) {
      modifiedItem.remainingOtherExpensesValue = item?.remainingOtherExpensesValue;
    }

    if (devolutionLinkage?.devolutionInvoiceId && devolutionLinkage?.devolutionItemId) {
      // Lets the backend capture the exact before/after delta this update consumes
      // and snapshot it onto the devolution's own item, so a later reversal can
      // restore precisely what was debited here (see DevolutionBalanceReversalService).
      modifiedItem.devolutionInvoiceId = devolutionLinkage.devolutionInvoiceId;
      modifiedItem.devolutionItemId = devolutionLinkage.devolutionItemId;
    }

    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const resp = await this._http.put(url, modifiedItem, options).pipe(first()).toPromise();
    return resp;
  }

  private removeNullValuesOf<T>(array: T[]): T[] {
    for (const item of array) {
      for (const key of Object.keys(item)) {
        if (item[key] === null) {
          delete item[key];
        }
      }
    }
    return array;
  }

  async updateInvoiceState(invoiceId: string, state: number, cnpj: string, isNFSE = false) {
    if (!invoiceId) {
      return;
    }
    const url = `${this.URL}/v1/invoice-mkgo/${isNFSE ? 'nfse' : 'nfce'}/${invoiceId}/state/${state}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const resp = await this._http.put(url, null, options).pipe(first()).toPromise();
    return resp as any;
  }

  /** @todo test */
  async getImportedInvoices(): Promise<ImportedInvoice[]> {
    const url = `${this.URL}/v1/invoice`;
    const header = await firstValueFrom(this._dataService.httpOptions(false));
    const resp: ImportedInvoice[] = await this._http.get(url, header).pipe(first()).toPromise() as any;
    return resp;
  }

  /** @todo test */
  async updateImportedInvoice(invoiceId: string, eventType: number) {
    const url = `${this.URL}/v1/invoice/api/${invoiceId}`;
    const header = await firstValueFrom(this._dataService.httpOptions(false));
    const body = {
      eventType: eventType
    }
    const resp: any = await this._http.post(url, body, header).pipe(first()).toPromise();
    return resp;
  }

  /** @todo test */
  async getImportedByNSU(nsu: number) {
    const url = `${this.URL}/v1/invoice/${nsu}`;
    const header = await firstValueFrom(this._dataService.httpOptions(false));
    const resp: any = await this._http.get(url, header).pipe(first()).toPromise();
    return resp;
  }

  /**
   * Use to check if an invoice already is existent
   * @param invoiceNumber
   * @param serie
   * @param cnpjEmitente The cnpj of emitent/prestador
   * @param companyCnpj The cnpj of company to find the invoice
   * @returns A Promise with the error if the invoice is existent, otherwise null
   */
  async isInvoiceExistent(invoiceNumber: number | string, serie: string, cnpjEmitente: string, companyCnpj: string, model: "nfce" | "nfse"): Promise<boolean> {
    const unmasked = Utilities.removeMask(cnpjEmitente);
    const url = `${this.URL}/v1/invoice-mkgo/${model}/index/${invoiceNumber}/${serie}/${unmasked}`;
    const header = await firstValueFrom(this._dataService.httpOptions(companyCnpj));
    return firstValueFrom(this._http.get<{ id: ObjectId }>(url, header)
      .pipe(
        first(),
        catchError((error, _caught) => {
          if (error instanceof HttpErrorResponse) {
            switch (error.error.error) {
              case API_ERRORS.notFound:
                // the API not found an invoice with these config
                return of(false);
              default:
                console.error(`A nota nº${invoiceNumber}, serie ${serie} para o cliente ${cnpjEmitente} já existe`, error.error);
                return of(true);
            }
          }
          console.error(`A nota nº${invoiceNumber}, serie ${serie} para o cliente ${cnpjEmitente} já existe`, error);
          return of(true);
        }),
        map((resp) => {
          if (typeof resp == 'boolean') {
            return resp;
          }
          return Boolean(resp.id);
        })
      ));
  }

  async getUpdatedNF(invoice: NF_response, model: "NFe" | "NFCe") {
    const url = `${this.URL}/v1/invoice-mkgo/${model.toLowerCase()}/api/query/${invoice.id}`;
    const cnpj = this._invoicePropertyPipe.transform(invoice, 'cnpj', this._dataService.company);
    const header = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const body = {
      NumeroInicial: Number(this._invoicePropertyPipe.transform(invoice, 'number')),
      NumeroFinal: Number(this._invoicePropertyPipe.transform(invoice, 'number')),
      Serie: this._invoicePropertyPipe.transform(invoice, 'serie').toString(),
      CnpjEmissor: Utilities.removeMask(cnpj),
      CnpjEmpresa: Utilities.removeMask(cnpj),
      ModeloDocumento: this._invoicePropertyPipe.transform(invoice, 'model'),
    };
    return firstValueFrom(this._http.post<MigrateQueryResponse>(url, body, header));
  }

  async getUpdatedNFSe(invoice: NFSE_response) {
    const url = `${this.URL}/v1/invoice-mkgo/nfse/api/query/${invoice.id}`;
    const cnpj = this._invoicePropertyPipe.transform(invoice, 'cnpj', this._dataService.company);
    const header = await firstValueFrom(this._dataService.httpOptions(cnpj));
    const body = {
      NumeroInicial: Number(this._invoicePropertyPipe.transform(invoice, 'number')),
      NumeroFinal: Number(this._invoicePropertyPipe.transform(invoice, 'number')),
      Serie: this._invoicePropertyPipe.transform(invoice, 'serie'),
      CnpjEmissor: Utilities.removeMask(cnpj),
      CnpjEmpresa: Utilities.removeMask(cnpj),
      ModeloDocumento: this._invoicePropertyPipe.transform(invoice, 'model'),
    };
    return firstValueFrom(this._http.post<MigrateQueryResponse>(url, body, header));
  }

  async getTagCobr(finances: Finance[], OS?: MkgOS): Promise<NFe['cobr'] | null> {
    if (!finances || !finances.length) {
      return null;
    }

    // calculating title values
    let fullValue = finances.reduce((acc, finance) => acc + finance.value, 0);
    fullValue = Number(fullValue.toFixed(2));

    let vOrig = fullValue;
    let vLiq = fullValue;
    let vDesc_cob = 0;
    if (OS) {
      vOrig = OS.liquidValueParts;
      vDesc_cob = 0;
      vLiq = OS.liquidValueParts;
    }

    const cobr: NFe['cobr'] = {
      fat: {
        nFat: '1',
        vDesc_cob,
        vLiq,
        vOrig
      },
      dup: []
    };

    for (const finance of finances) {
      let financeDups: NFe['cobr']['dup'] = [];

      // calculate the percentage of total this payment represents
      const conditionPercentage = Utilities.getPercentage(finance.value, fullValue, 10);
      const conditionValue = Utilities.calcPercentage(conditionPercentage, vLiq, "round", 10);

      const firstParcelPercentage = Math.floor(finance.paymentCondition.parcels[0].percentage);
      if (finance.paymentCondition.parcels.every(p => Math.floor(p.percentage) === firstParcelPercentage)) {
        // all parcels have the same value
        let parcelValue = conditionValue / finance.paymentCondition.parcels.length;
        let parcelDups: NFe['cobr']['dup'] = [];
        if (finance.paymentCondition.form === PAYMENT_METHODS.credit) {
          const parcel = finance.paymentCondition.parcels[0];
          let expiration = parcel.expirationDate || await firstValueFrom(this._cashTitleService.getExpirationDate(parcel.days));
          if (finance.previewTitles?.length) {
            const customParcel = finance.previewTitles.find(pt => pt.parcel === parcel.seq);
            parcelValue = customParcel?.value;
            expiration = customParcel?.expiration;
          }

          let expirationMoment = moment(expiration);
          if (expirationMoment.isBefore(moment())) {
            /** Avoid rejection 900: 'Data de vencimento da parcela não informada ou menor que Data de Emissão' */
            expirationMoment = moment();
          }

          parcelDups.push({
            dVenc: expirationMoment.format("yyyy-MM-DD"),
            vDup: Number((parcelValue).toFixed(2)),
            nDup: ""
          });
        } else {
          for (const parcel of finance.paymentCondition.parcels) {
            let expiration = parcel.expirationDate || await firstValueFrom(this._cashTitleService.getExpirationDate(parcel.days));
            if (finance.previewTitles?.length) {
              const customParcel = finance.previewTitles.find(pt => pt.parcel === parcel.seq);
              parcelValue = customParcel?.value;
              expiration = customParcel?.expiration;
            }

            let expirationMoment = moment(expiration);
            if (expirationMoment.isBefore(moment())) {
              /** Avoid rejection 900: 'Data de vencimento da parcela não informada ou menor que Data de Emissão' */
              expirationMoment = moment();
            }

            parcelDups.push({
              dVenc: expirationMoment.format("yyyy-MM-DD"),
              vDup: Number((parcelValue).toFixed(2)),
              nDup: ""
            });
          }
        }

        Utilities.fixCentsDifference(parcelDups, 'vDup', conditionValue);
        financeDups = financeDups.concat(parcelDups);

      } else {
        let parcelDups: NFe['cobr']['dup'] = [];
        if (finance.paymentCondition.form === PAYMENT_METHODS.credit) {
          const parcel = finance.paymentCondition.parcels[0];
          let parcelValue = Utilities.calcPercentage(parcel.percentage, conditionValue);
          let expiration = parcel.expirationDate || await firstValueFrom(this._cashTitleService.getExpirationDate(parcel.days));
          if (finance.previewTitles?.length) {
            const customParcel = finance.previewTitles.find(pt => pt.parcel === parcel.seq);
            parcelValue = customParcel?.value;
            expiration = customParcel?.expiration;
          }

          let expirationMoment = moment(expiration);
          if (expirationMoment.isBefore(moment())) {
            /** Avoid rejection 900: 'Data de vencimento da parcela não informada ou menor que Data de Emissão' */
            expirationMoment = moment();
          }

          parcelDups.push({
            dVenc: expirationMoment.format("yyyy-MM-DD"),
            vDup: Number(parcelValue.toFixed(2)),
            nDup: ""
          });
        } else {
          for (const parcel of finance.paymentCondition.parcels) {
            let parcelValue = Utilities.calcPercentage(parcel.percentage, conditionValue);
            let expiration = parcel.expirationDate || await firstValueFrom(this._cashTitleService.getExpirationDate(parcel.days));
            if (finance.previewTitles?.length) {
              const customParcel = finance.previewTitles.find(pt => pt.parcel === parcel.seq);
              parcelValue = customParcel?.value;
              expiration = customParcel?.expiration;
            }

            let expirationMoment = moment(expiration);
            if (expirationMoment.isBefore(moment())) {
              /** Avoid rejection 900: 'Data de vencimento da parcela não informada ou menor que Data de Emissão' */
              expirationMoment = moment();
            }

            parcelDups.push({
              dVenc: expirationMoment.format("yyyy-MM-DD"),
              vDup: Number(parcelValue.toFixed(2)),
              nDup: ""
            });
          }
        }

        Utilities.fixCentsDifference(parcelDups, 'vDup', conditionValue);
        financeDups = financeDups.concat(parcelDups);
      }

      if (finances?.length === 1 && (finance.previewTitles?.length === 1 || finance?.paymentCondition?.parcels?.length === 1)) {
        const paymentCondition = await this._paymentService.getById(
          finance.paymentCondition?.condition?.["_id"]
          ?? finance.paymentCondition?.condition?.["id"]
          ?? finance.paymentCondition.condition
        );
        const previewTitleDay = moment(finance.previewTitles?.[0]?.expiration ?? finance?.paymentCondition?.parcels[0]?.expirationDate);
        const currentDay = moment();

        const conditionWithoutDiacritics = Utilities.removeDiacritics(paymentCondition.condition?.toLowerCase() ?? "");
        if ((conditionWithoutDiacritics === "a vista") || currentDay.isSame(previewTitleDay, "day")) {
          financeDups = [];
        }
      }

      cobr.dup = cobr.dup.concat(financeDups);
    }

    Utilities.fixCentsDifference(cobr.dup, "vDup", vLiq);

    // sort parcels by expiration date
    cobr.dup = cobr.dup.sort((dup1, dup2) => moment(dup1.dVenc).isAfter(moment(dup2.dVenc)) ? 1 : -1);

    // set nDup
    for (let index = 0; index < cobr.dup.length; index++) {
      cobr.dup[index].nDup = `${index + 1}`.padStart(3, '0');
    }

    return cobr;
  }

  async getNFById(id: string, cnpj?: string) {
    const url = `${this.URL}/v1/invoice-mkgo/nfce/${id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.get<NF_response>(url, options).pipe(first()));
  }

  async getNFSEById(id: string, cnpj?: string) {
    const url = `${this.URL}/v1/invoice-mkgo/nfse/${id}`;
    const options = await firstValueFrom(this._dataService.httpOptions(cnpj));
    return firstValueFrom(this._http.get<NFSE_response>(url, options).pipe(first()));
  }

  async _getNextNumberAndSerieFor(getNextNumberAndSerieFor: Company, emitterCNPJ: string, docType: "NFe" | "NFCe" | "NFSe", isFiscal: boolean, updateTheInvoiceNumber = true) {
    let numero: number;
    let serie: number;
    let isExistent = false;
    const MAX_ATTEMPS = 15;// prevent infinite looping
    let attemps = 0;

    if (isFiscal) {
      switch (docType) {
        case 'NFe':
          numero = Number(getNextNumberAndSerieFor.numberInvoice);
          serie = getNextNumberAndSerieFor.serieInvoice;
          break;
        case 'NFCe':
          numero = Number(getNextNumberAndSerieFor.numberInvoiceNFC);
          serie = getNextNumberAndSerieFor.serieInvoiceNFC;
          break;
        case 'NFSe':
          numero = Number(getNextNumberAndSerieFor.numberInvoiceNFS);
          serie = getNextNumberAndSerieFor.serieInvoiceNFS;
          break;
      }
    } else {
      numero = Number(getNextNumberAndSerieFor.numberGerencial);
      serie = getNextNumberAndSerieFor.serieGerencial;
    }

    do {
      // increase number until find a not existent combination
      isExistent = await this.isInvoiceExistent(numero + attemps, `${serie}`, emitterCNPJ, getNextNumberAndSerieFor.cnpj, docType == "NFSe" ? 'nfse' : 'nfce');
      if (isExistent) {
        attemps++;
      }
    } while (isExistent && attemps < MAX_ATTEMPS);

    if (!updateTheInvoiceNumber) {
      return { numero, serie }
    }

    if (attemps >= MAX_ATTEMPS) {
      const docName = isFiscal ? docType : "Operação interna";
      alert(`A ${docName} de Número:${numero}, Série: ${serie} para o Cliente: ${emitterCNPJ} já existe. Verifique numeração e tente novamente.`);
      return {
        numero, serie
      }
    } else {
      numero += attemps;
      const nextNumber = numero + 1;
      // update company with rigth value for the next emission
      if (isFiscal) {
        switch (docType) {
          case 'NFe':
            getNextNumberAndSerieFor.numberInvoice = `${numero}`;
            this._companyService.setInvoiceNumber(getNextNumberAndSerieFor.cnpj, 'numberInvoice', nextNumber)
              .pipe(first())
              .subscribe();
            break;
          case 'NFCe':
            getNextNumberAndSerieFor.numberInvoiceNFC = `${numero}`;
            this._companyService.setInvoiceNumber(getNextNumberAndSerieFor.cnpj, 'numberInvoiceNFC', nextNumber)
              .pipe(first())
              .subscribe();
            break;
          case 'NFSe':
            getNextNumberAndSerieFor.numberInvoiceNFS = `${numero}`;
            this._companyService.setInvoiceNumber(getNextNumberAndSerieFor.cnpj, 'numberInvoiceNFS', nextNumber)
              .pipe(first())
              .subscribe();
            break;
        }
      } else {
        getNextNumberAndSerieFor.numberGerencial = `${numero}`;
        this._companyService.setInvoiceNumber(getNextNumberAndSerieFor.cnpj, 'numberGerencial', nextNumber)
          .pipe(first())
          .subscribe();
      }
    }

    if (this._dataService.company.id == getNextNumberAndSerieFor.id) {
      this._dataService.company$.next(getNextNumberAndSerieFor);
    }
    return { numero, serie };
  }
}
